import { Alert } from "antd";
import qs from "query-string";
import { useEffect, useState } from "react";
import { persistLinkState } from "../hooks/useLinkTracker";
import { captureException } from "../sentry";
import Store from "../stateStore";
import { extractLinkParamsFromState, getBackendUrl, STORES } from "../utils";

type WaveProps = {
  clientSecret: string;
  onBack: () => void;
  onCancel: () => void;
  onComplete: (publicToken: string) => void;
};

function Wave({ clientSecret, onBack, onCancel, onComplete }: WaveProps) {
  const store = Store.useStore();
  const storeState = store.getState();
  const origin = store.get("origin");
  const nonce = store.get("nonce");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    handleComplete();
  }, []);

  function handleAuthError(e: any) {
    captureException(e);
    if (e.response.data.error_message) {
      setError(e.response.data.error_message);
    } else {
      setError(
        "An error occurred, but your credentials are secure. Please try again, or contact support.",
      );
    }
  }

  function handleComplete() {
    try {
      persistLinkState(STORES.WAVE, storeState);
      const q = qs.stringify(extractLinkParamsFromState(store));
      const url = `${getBackendUrl()}/wave/proxy/app-url?${q}`;
      window.location.replace(url);
    } catch (e) {
      handleAuthError(e);
    }
  }

  return (
    <>
      {error && (
        <Alert
          className="mt-4"
          type="error"
          message={"Error"}
          description={error}
          showIcon
        ></Alert>
      )}
    </>
  );
}

export default Wave;
